import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from '../../../../../core/services/auth.service';




@Injectable()
export class RecepcionVehiculoStepsService {

    private _currentStep;
    private _recepcionCustmer;
    public finishUpdate = new Subject<boolean>();
    public stepsLabels: string[] =
        [
            'labels.datos_vehiculo',
            'labels.datos_cliente',
            'taller.recepcion_vehiculo.stepLineaRecepcion',
            'taller.recepcion_vehiculo.stepDatosRecepcion',
            'alerts.alertaConfirm'
        ];

    constructor(
        private _authService: AuthService,
    ) {

    }
    observerFinishUpdate() {
        return this.finishUpdate.asObservable();
    }
    setUpdate() {
        this.finishUpdate.next(true);
    }

    setCurrentCustomer(value) {
        this._recepcionCustmer = value;
    }
    getCurrentCustomer() {
        return this._recepcionCustmer;
    }
    set currentStep(value) {
        this._currentStep = value;
    }

    get currentStep() {
        return this._currentStep;
    }
    reset() {
        this.currentStep = 0;
    }

    anterior() {
        if (this.currentStep > 0) {
            this.currentStep--;
        }
        if (this.currentStep === 0) {
        }
    }

    siguiente() {
        if (this.currentStep === 0) {
            this.currentStep++;
        } else if (this.currentStep === 1) {


        } else if (this.currentStep === 2) {

        } else if (this.currentStep === 3) {

        }
    }


    openNewSeating() {
        this.siguiente();
    }

    // observerAllDataCustomer() {
    //   return this.allDataCustomer.asObservable();
    // }

    // setAllDataCustomer(value) {
    //   this._datosCustomer = value;
    //   this.allDataCustomer.next(value);
    // }


}
